// config.js
export default {
  base_url:'https://procculapi.akkuratebank.com'
}